import { lazy } from 'react';

export const ModuleList = lazy(() => import('./module/ModuleList'));
export const ActionList = lazy(() => import('./action/ActionList'));
export const AddAction = lazy(() => import('./action/AddAction'));
export const UpdateAction = lazy(() => import('./action/UpdateAction'));
export const Permission = lazy(() => import('./permission/Permission'));
export const UserPermission = lazy(() => import('./user_permission/UserPermission'));
export const CompanyPermission = lazy(() => import('./company_permission/CompanyPermission'));
export const UserRoleList = lazy(() => import('./user_role/UserRoleList'));